import {
  Badge,
  Box,
  Button,
  Flex,
  Image,
  Input,
  Text,
  VStack,
} from "@chakra-ui/react";
import { Images } from "../../Assets/images";
import React, { useRef, useEffect, useState } from "react";
import Header from "../../Components/Common/Header";
import { Sellerscreens } from "../../Constants/data";
import { Modal } from "antd";
import { SellerAPI } from "../../Apis/sellerAPI";
import { useToastWrapper } from "../../Wrapper/toastWrapper";
import { errorHandler } from "../../Utils/handler";
// Claude: icon buttons for Edit + Delete 26-03-2026
import { MdDeleteOutline, MdOutlineEdit, MdArrowBack } from "react-icons/md"; // Claude: back button 27-03-2026
import AddUrlModal from "../../Components/Modals/AddUrlModal";
import ConfirmationModal from "../../Components/Modals/ConfirmationModal";
import { useNavigate } from "react-router-dom"; // Claude: back button 27-03-2026
import { useDispatch, useSelector } from "react-redux";
import actions from "../../redux/Actions";

type Props = {};

// Claude: replaced assetSummary with assetType badge 30-03-2026
type LinkItemProps = {
  id: string;
  title: string;
  url: string;
  assetType?: string;
  onEdit: () => void;
};

const SellerCatalog = (props: Props) => {
  const sellerAsset = useSelector((state: any) => state.sellerAsset);
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.user);
  const navigate = useNavigate(); // Claude: back button 27-03-2026

  const [userPlan, setUserPlan] = useState<any>({});

  const [tags, setTags] = useState<string[]>([]);
  const [tagInput, setTagInput] = useState("");
  const tagInputRef = useRef<HTMLInputElement>(null);
  const [sellerId, setSellerId] = useState<string>("");
  const [assetDeleteId, setAssetDeleteId] = useState<string>("");
  const [deleteConfirm, setDeleteConfirm] = useState<boolean>(false);
  // Claude: edit mode — track which asset is being edited 30-03-2026
  const [editAsset, setEditAsset] = useState<{ _id: string; assetTitle: string; assetUrl: string; assetType?: string } | null>(null);
  const handleOpenDeleteConfirm = () => setDeleteConfirm(true);
  const handleCloseDeleteConfirm = () => {
    setAssetDeleteId("");
    setDeleteConfirm(false);
  };

  const { error, success } = useToastWrapper();

  // add url Modal
  const [addUrl, setAddUrl] = useState(false);
  const handleOpenAddUrlModal = () => { setEditAsset(null); setAddUrl(true); };
  const handleCloseAddUrlModal = () => {
    dispatch(actions.sellerAssets.resetForm({}));
    setEditAsset(null);
    setAddUrl(false);
  };
  // Claude: open modal in edit mode with pre-filled asset 30-03-2026
  const handleOpenEditModal = (asset: { _id: string; assetTitle: string; assetUrl: string; assetType?: string }) => {
    setEditAsset(asset);
    setAddUrl(true);
  };

  const getPlanDetails = async () => {
    try {
      const userId = user.user;
      const [planDetails] = await Promise.all([
        SellerAPI.getEventSellerProfile(userId),
      ]);

      if (planDetails) {
        setUserPlan(planDetails?.data?.data);
      }
    } catch (err) {
      error("Unable to get subscription details!");
    }
  };

  // Claude: LinkItem — shows title, asset type badge, Edit + Delete buttons 30-03-2026
  const LinkItem: React.FC<LinkItemProps> = ({ id, title, url, assetType, onEdit }) => {
    return (
      <Box
        key={id}
        width={"100%"}
        pt={3} pb={3} pl={2} pr={2} mb={2}
        border={"1px"} borderColor={"gray.200"}
      >
        <Flex justifyContent={"space-between"} alignItems={"flex-start"}>
          <Box flex={1} mr={2}>
            <Text fontSize={"sm"} fontWeight={500} color={"#0E122F"} wordBreak="break-word">{title}</Text>
            {assetType && (
              <Text fontSize={"10px"} fontWeight={500} px={2} py={"1px"} borderRadius={"full"}
                bg={"#E8F5E9"} color={"#2E7D32"} display={"inline-block"} mt={1}>
                {assetType}
              </Text>
            )}
          </Box>
          {/* Claude: icon buttons for Edit + Delete 26-03-2026 */}
          <Flex gap={1} flexShrink={0} alignItems="center">
            <Button size="xs" variant="ghost" color="#0E122F" _hover={{ bg: "gray.100" }} onClick={onEdit} aria-label="Edit">
              <MdOutlineEdit size={17} />
            </Button>
            <Button size="xs" variant="ghost" color="#C62828" _hover={{ bg: "red.50" }} onClick={() => { setAssetDeleteId(id); handleOpenDeleteConfirm(); }} aria-label="Delete">
              <MdDeleteOutline size={17} />
            </Button>
          </Flex>
        </Flex>
      </Box>
    );
  };

  const getData = async () => {
    try {
      const res = await SellerAPI.getSellerProfile();
      if (res) {
        // console.log("Response for seller profile",res);
        setTags(res.data.data?.productTypeTags);
        // setSellerId(res.data.data?.userId);
        setSellerId(res.data.data?._id);

      }
    } catch (err) {
      console.log(err);
      error(errorHandler(err));
    }
  };

  const getAssets = async () => {
    try {
      // const res = await SellerAPI.getAssets();
      const res = await SellerAPI.getSellerAssets(sellerId);
      
      if (res) {
        console.log("this is res inside add url..", res);

        dispatch(actions.sellerAssets.setAssets({ links: res.data.data }));
      }
    } catch (err) {
      console.log(err);
      error(errorHandler(err));
    }
  };

  const handleUpdate = async () => {
    // Claude: enforce 50-char limit per tag on save 20-03-2026
    const overLimitTags = tags.filter((t) => t.length > 50);
    if (overLimitTags.length) {
      error(`Tags must be 50 characters or fewer: ${overLimitTags.join(", ")}`, "");
      return;
    }
    if (userPlan.sellerTagsLimit !== -1 && tags.length > userPlan.sellerTagsLimit) { // Claude: -1 = unlimited 21-04-2026
      error(
        "Max number of tags that can be created is " +
          userPlan.sellerTagsLimit,
        ""
      );
      return;
    }
    try {
      const res = await SellerAPI.updateSellerProfile({
        productTypeTags: tags,
      });
      if (res) {
        success("Updated Successfully");
      }
    } catch (err) {
      console.log(err);
      error(errorHandler(err));
    }
  };

  const deleteSellerAsset = async (assetId: string) => {
    try {
      const res = await SellerAPI.deleteAsset(assetId);
      if (res) {
        getAssets();
        success("Asset deleted", "");
      }
    } catch (err) {
      console.log(err);
      error(errorHandler(err));
    }
  };


  useEffect(() => {
    // Claude: N47 — set active nav to Catalog 26-03-2026
    dispatch(actions.sellerMenu.set({ activeMenu: Sellerscreens.CATALOG }));
    getData();
    getPlanDetails();
    // Claude: auto-focus tag input on mount so cursor is immediately visible 28-03-2026
    setTimeout(() => tagInputRef.current?.focus(), 300);
  }, []);
  
  useEffect(() => {
    if (sellerId) {
      getAssets(); 
    }
  }, [sellerId]);

  return (
    // Claude: Light blue bg for consistency with other seller screens 17-02-2026
    <Box
      w={"100%"}
      display={"flex"}
      flexDirection={"column"}
      alignItems={"center"}
      bg={"linear-gradient(180deg, #EFF6FF 0%, #FFFFFF 100%)"}
      minH={"100dvh"}
      maxH={"100dvh"}
    >
      {/* Claude: destroyOnClose forces remount — prevents stale Redux state pre-filling add modal 26-03-2026 */}
      <Modal
        closeIcon={null}
        footer={null}
        title={null}
        open={addUrl}
        onOk={handleCloseAddUrlModal}
        onCancel={handleCloseAddUrlModal}
        destroyOnClose
      >
        {/* Claude: pass editAsset for edit mode; null for add mode 25-03-2026 */}
        <AddUrlModal
          addUrl
          handleCloseModal={handleCloseAddUrlModal}
          sellerId={sellerId}
          editAsset={editAsset}
        />
      </Modal>

      <Modal
        closeIcon={null}
        footer={null}
        title={null}
        open={deleteConfirm}
        onOk={handleCloseDeleteConfirm}
        onCancel={handleCloseDeleteConfirm}
      >
        <ConfirmationModal
          handleCloseModal={handleCloseDeleteConfirm}
          handleSubmit={() => {
            deleteSellerAsset(assetDeleteId);
            handleCloseDeleteConfirm();
          }}
          title={"Delete URL"}
          message={
            "Are you sure you want to delete this URL? This action cannot be undone."
          }
          confirmBtnText={"Yes, Delete"}
          rejectButtonText={"No"}
        />
      </Modal>

      {/* Claude: Dark header with "Digital Assets" title matching other pages 16-02-2026 */}
      {/* Claude: AFTR logo on right side of dark header 23-02-2026 */}
      <Flex
        w={"100%"}
        px={"30px"}
        py={5}
        bg={"#0E122F"}
        color={"white"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        {/* Claude: back button 27-03-2026 */}
        <Flex alignItems="center" gap={3} cursor="pointer" onClick={() => navigate(-1)}>
          <MdArrowBack size={20} color="white" />
          <Text fontSize={"xl"} fontWeight={700}>Digital Assets</Text>
        </Flex>
        {/* Claude: role label below logo in header 25-02-2026 */}
        <VStack spacing={0} alignItems="center" justifyContent="center">
          <Image src={Images.AftrLogo} h="32px" objectFit="contain" />
          <Text fontSize="11px" fontWeight={300} color="whiteAlpha.600" letterSpacing="wide">
            seller (beta)
          </Text>

        </VStack>
      </Flex>

      {/* Claude: single combined hint line above tag input 26-03-2026 */}
      <Text mt={"16px"} px={4} fontSize={"12px"} color={"gray.500"}>
        Add generic tags related to your products and services. Buyers can use tags in their search. Each tag must be 50 characters or fewer. Type and press Enter to add.
      </Text>

      {/* Claude: tag chip input + Save inline — matches buyer BrowseTags Badge style 26-03-2026 */}
      <Flex w={"100%"} px={4} gap={2} alignItems={"flex-start"} mt={1}>
        <Box
          flex={1} cursor="text"
          onClick={() => tagInputRef.current?.focus()}
        >
          <Flex
            flexWrap="wrap" gap={2} p={2}
            bg="#E8F5E9" borderRadius="8px" minH="44px"
            alignItems="center"
          >
            {tags.map((tag) => (
              <Badge
                key={tag}
                px={3} py={1} borderRadius="full"
                bg="gray.100" color="gray.600"
                border="1px solid" borderColor="gray.200"
                cursor="pointer"
                fontSize="xs" fontWeight={400}
                textTransform="none"
                display="flex" alignItems="center"
                _hover={{ bg: "#E2E8F0", borderColor: "#CBD5E0" }}
              >
                {tag}
                <Box
                  as="span" ml={1} cursor="pointer" color="gray.400"
                  _hover={{ color: "#C62828" }}
                  onClick={(e) => { e.stopPropagation(); setTags(tags.filter((t) => t !== tag)); }}
                >
                  ×
                </Box>
              </Badge>
            ))}
            <Input
              ref={tagInputRef}
              value={tagInput}
              onChange={(e) => {
                const raw = e.target.value;
                // Claude: GBoard fires →| key as \n in onChange — treat as tag submit 28-03-2026
                if (raw.includes("\n") || raw.includes(",")) {
                  const val = raw.replace(/[\n,]/g, "").trim().toUpperCase();
                  if (val && !tags.includes(val)) setTags([...tags, val]);
                  setTagInput("");
                } else {
                  setTagInput(raw.toUpperCase().slice(0, 50));
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === ",") {
                  e.preventDefault();
                  const val = tagInput.trim().toUpperCase();
                  if (val && !tags.includes(val)) setTags([...tags, val]);
                  setTagInput("");
                } else if (e.key === "Backspace" && !tagInput && tags.length) {
                  setTags(tags.slice(0, -1));
                }
              }}
              placeholder={tags.length === 0 ? "Type a tag and press Enter…" : ""}
              border="none" outline="none" _focus={{ boxShadow: "none" }}
              h="28px" px={1} fontSize="xs" flex={1} minW="120px"
              enterKeyHint="done" sx={{ caretColor: "black" }}
            />
          </Flex>
        </Box>
        {/* Claude: Save button inline with tag box — pill chip style 26-03-2026 */}
        <Button
          onClick={handleUpdate}
          bg={"#0E122F"} color={"white"}
          px={3} py={1} h={"auto"} minH={"auto"}
          borderRadius={"full"} fontSize={"xs"} fontWeight={400}
          _hover={{ bg: "#2E7D32" }}
        >
          Save
        </Button>
      </Flex>

      {/* Claude: Catalog section header 23-02-2026 */}
      <Box
        w={"100%"}
        px={4}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        mt={3}
        mb={1}
      >
        <Text fontSize={"18px"} fontWeight={700}>
          Catalog and Digital Assets
        </Text>
        {/* Claude: Add button — pill chip style matching tag badges 26-03-2026 */}
        <Button
          bg="#0E122F" color="white"
          px={3} py={1} h={"auto"} minH={"auto"}
          borderRadius={"full"} fontSize={"xs"} fontWeight={400}
          _hover={{ bg: "#2E7D32" }}
          onClick={() => {
            if (userPlan.digitalAssetsLimit !== -1 && sellerAsset.links.length >= userPlan.digitalAssetsLimit) { // Claude: -1 = unlimited 21-04-2026
              return error("Max number of digital assets that can be created is " + userPlan.digitalAssetsLimit);
            }
            handleOpenAddUrlModal();
          }}
        >
          Add
        </Button>
      </Box>
      <Text fontSize={"12px"} color={"gray.500"} px={4} mb={3}>
        This is where you wow your prospect! Add links to your company sales decks, products / services / solutions details, videos and other marketing assets. For each asset, you can create a short-n-sweet, crisp summary that remains etched in your prospect's mind!
      </Text>
      <Box w={"100%"} px={4}>
        {typeof sellerAsset.links != "string" &&
        sellerAsset.links.length > 0 ? (
          // Claude: pass assetType + onEdit handler to each LinkItem 30-03-2026
          sellerAsset.links.map((link: any) => (
            <LinkItem
              key={link._id}
              id={link._id}
              title={link.assetTitle}
              url={link.assetUrl}
              assetType={link.assetType}
              onEdit={() => handleOpenEditModal({ _id: link._id, assetTitle: link.assetTitle, assetUrl: link.assetUrl, assetType: link.assetType })}
            />
          ))
        ) : (
          <Text fontSize={"14px"} fontWeight={"light"}>
            No assets attached
          </Text>
        )}
      </Box>
    </Box>
  );
};

export default SellerCatalog;
